import React from "react";

interface DraftNotificationProps {
    hasDraft: boolean;
    onClearDraft: () => void;
}

export const DraftNotification: React.FC<DraftNotificationProps> = ({
    hasDraft,
    onClearDraft
}) => {
    if (!hasDraft) return null;

    return (
        <div className="bg-blue-100 border border-blue-400 text-blue-700 px-3 py-2 sm:px-4 sm:py-3 rounded mb-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
            <span>You have a saved draft of this form.</span>
            <button
                onClick={onClearDraft}
                className="text-sm bg-blue-500 hover:bg-blue-600 text-white py-1 px-3 rounded self-end sm:self-auto"
            >
                Clear Draft
            </button>
        </div>
    );
};
